import React from 'react';
import Spinner from '@atlaskit/spinner';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Layout from 'antd/lib/layout';
import 'antd/lib/grid/style/index.css';
import 'antd/lib/layout/style/index.css';
var Header = Layout.Header, Content = Layout.Content, Footer = Layout.Footer;
import InlineDisplay from './InlineDisplay';
import ColorBlock from './ColorBlock';
var typoStyles = require('src/imports/styles/styles.typography.scss');
var selfStyles = require('./styles.scss');
var logoBig = require('src/assets/logo/crimp-icon@0,5x.png');
var logoMedium = require('src/assets/logo/crimp-icon@0,25x.png');
var logoSmall = require('src/assets/logo/favicon-64.png');
import SpinnerCrimp from '../components/utilities/SpinnerCrimp';
import ButtonAction from '../components/utilities/ButtonAction';
var PageKitchen = function () { return (React.createElement(Layout, { className: selfStyles.kitchen },
    React.createElement(Header, null,
        React.createElement("strong", null,
            React.createElement("h1", { className: typoStyles.crimp, style: { color: 'white' } }, "CRIMP KITCHEN SINK"))),
    React.createElement(Content, null,
        React.createElement("section", { className: selfStyles.section },
            React.createElement("h2", null, "LOGO"),
            React.createElement(Row, null,
                React.createElement(InlineDisplay, { component: React.createElement("img", { src: logoSmall }), label: 'favicon-64.png', info: '64px, 2kb' }),
                React.createElement(InlineDisplay, { component: React.createElement("img", { src: logoMedium }), label: 'crimp-icon@0,25x', info: '256px, 9kb' }),
                React.createElement(InlineDisplay, { component: React.createElement("img", { src: logoBig }), label: 'crimp-icon@0,5x', info: '512px, 18kb' }))),
        React.createElement("section", { className: selfStyles.section },
            React.createElement("h2", null, "Colors"),
            React.createElement(Row, null,
                React.createElement(InlineDisplay, { component: React.createElement(ColorBlock, { color: '#172B4D' }), label: 'Text', info: '' }),
                React.createElement(InlineDisplay, { component: React.createElement(ColorBlock, { color: '#0065FF' }), label: 'Action', info: 'Marvel' }),
                React.createElement(InlineDisplay, { component: React.createElement(ColorBlock, { color: '#13CE66' }), label: 'Positive', info: 'Marvel' }),
                React.createElement(InlineDisplay, { component: React.createElement(ColorBlock, { color: '#FFC82C' }), label: 'Warning', info: 'Marvel' }),
                React.createElement(InlineDisplay, { component: React.createElement(ColorBlock, { color: '#FF4949' }), label: 'Negative', info: 'Marvel' })),
            React.createElement(Row, null,
                React.createElement(InlineDisplay, { component: React.createElement(ColorBlock, { color: '#36B37E' }), label: 'Positive', info: 'Atlassian' }),
                React.createElement(InlineDisplay, { component: React.createElement(ColorBlock, { color: '#FFAB00' }), label: 'Warning', info: 'Atlassian' }),
                React.createElement(InlineDisplay, { component: React.createElement(ColorBlock, { color: '#FF5630' }), label: 'Negative', info: 'Atlassian' }))),
        React.createElement("section", { className: selfStyles.section },
            React.createElement("h2", null, "TYPOGRAPHY"),
            React.createElement(Row, null,
                React.createElement(Col, { span: 8 },
                    React.createElement("h3", null, "with LeagueSpartan font"),
                    React.createElement("p", { className: typoStyles.text800 + " " + typoStyles.crimp }, "Text800"),
                    React.createElement("p", { className: typoStyles.text700 + " " + typoStyles.crimp }, "Text700"),
                    React.createElement("p", { className: typoStyles.text600 + " " + typoStyles.crimp }, "Text600"),
                    React.createElement("p", { className: typoStyles.text500 + " " + typoStyles.crimp }, "Text500"),
                    React.createElement("p", { className: typoStyles.text400 + " " + typoStyles.crimp }, "Text400"),
                    React.createElement("p", { className: typoStyles.text300 + " " + typoStyles.crimp }, "Text300"),
                    React.createElement("p", { className: typoStyles.text200 + " " + typoStyles.crimp }, "Text200")),
                React.createElement(Col, { span: 8 },
                    React.createElement("h3", null, "with (header) font"),
                    React.createElement("p", { className: typoStyles.text800 }, "Text800"),
                    React.createElement("p", { className: typoStyles.text700 }, "Text700"),
                    React.createElement("p", { className: typoStyles.text600 }, "Text600"),
                    React.createElement("p", { className: typoStyles.text500 }, "Text500"),
                    React.createElement("p", { className: typoStyles.text400 }, "Text400"),
                    React.createElement("p", { className: typoStyles.text300 }, "Text300"),
                    React.createElement("p", { className: typoStyles.text200 }, "Text200")),
                React.createElement(Col, { span: 8 },
                    React.createElement("h3", null, "with (text) font"),
                    React.createElement("p", { className: typoStyles.text800 }, "Text800"),
                    React.createElement("p", { className: typoStyles.text700 }, "Text700"),
                    React.createElement("p", { className: typoStyles.text600 }, "Text600"),
                    React.createElement("p", { className: typoStyles.text500 }, "Text500"),
                    React.createElement("p", { className: typoStyles.text400 }, "Text400"),
                    React.createElement("p", { className: typoStyles.text300 }, "Text300"),
                    React.createElement("p", { className: typoStyles.text200 }, "Text200"))),
            React.createElement(Row, null,
                React.createElement(Col, { span: 12, offset: 0 },
                    React.createElement("h3", null, "Paragraph"),
                    React.createElement("p", { className: typoStyles.textParagraph }, "We spend a huge amount of our time at work. So the more that time doesn\u2019t feel like \u201Cwork,\u201D the better. We can be serious, without taking ourselves too seriously. We strive to put what\u2019s right for the team first \u2013 whether in a meeting room or on a football pitch. We spend a huge amount of our time at work. So the more that time doesn\u2019t feel like \u201Cwork,\u201D the better. We can be serious, without taking ourselves too seriously. We strive to put what\u2019s right for the team first \u2013 whether in a meeting room or on a football pitch.")))),
        React.createElement("section", { className: selfStyles.section },
            React.createElement("h2", null, "ButtonAction"),
            React.createElement(ButtonAction, null,
                React.createElement("button", null, "ButtonAction")),
            React.createElement(ButtonAction, { isWaiting: true }),
            React.createElement(ButtonAction, { isDisabled: true },
                React.createElement("button", null, "Disabled ButtonAction")),
            React.createElement(ButtonAction, { width: '300px' },
                React.createElement("button", null, "300px width"))),
        React.createElement("section", { className: selfStyles.section },
            React.createElement("h2", null, "Spinners"),
            React.createElement(Spinner, null),
            React.createElement(Spinner, { size: 'medium' }),
            React.createElement(Spinner, { size: 'large' }),
            React.createElement(Spinner, { size: 'xlarge' }),
            React.createElement(SpinnerCrimp, null),
            React.createElement(SpinnerCrimp, { size: 'medium' }),
            React.createElement(SpinnerCrimp, { size: 'large' }))),
    React.createElement(Footer, null,
        React.createElement("p", null, "This is a footer")))); };
export default PageKitchen;



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageKitchen/index.tsx
// module id = 1324
// module chunks = 0